import { default as Item , View } from './item'
import listComponent from '@/util/proto/listComponent'
import { createDict } from '@/util/dicts'
import global from '@/util/mixin/global'


export default {
  extends: listComponent,
  mixins:[global],
  data() {
    return {
      columns: [
        {
          type: 'index',
          width: 65,
          title: '序号',
          align: 'center'
        },
        {
          title: '标题',
          key: 'title',
          minWidth: 350,
          render:(h , {row}) => {
            return  <div style={{ display: 'flex', alignItems: 'center' }}>
              <div style={{'flex':'1 1 auto'}}>
                <div class="tb-list-item-cell">
                  <div class="tb-list-item-cell-l">
                    <span>{row.title}</span>
                  </div>
                  <div class="tb-list-item-cell-r">
                    <span style="margin-right:8px;">{row.organizationName}</span><span>{row.creator}</span>
                  </div>
                </div>
                <div class="tb-list-item-cell">
                  <div class="tb-list-item-cell-l light">
                  {
                    (row.details || []).map(i => <sl-tag style={{'fontSize':'10px','opacity':'0.75'}}>{i.companyName}</sl-tag>)
                  }
                  </div>
                  <div class="tb-list-item-cell-r">
                    <span>{row.createDatetimeText}</span>
                  </div>
                </div>
              </div>
            </div>
          }
        },
        {
          title: '操作',
          key: 'action',
          width: 200,
          align: 'center',
          fixed:'right',
          render: (h, params) => {
            let node = []
            let { status , pubId , pubUserType } = params.row
            //if( this.$a('company.inspection.query') ){
              node.push( <a on-click={()=>this.view(params)}>查看</a> )
            //}

            //if(this.$a('company.inspection.edit')){
              node.push( <a on-click={()=>this.edit(params)}>编辑</a> )
            //}

            //if(this.$a('company.inspection.remove')){
              node.push( <a on-click={()=>this.remove(params)}>删除</a> )
            //}
           
            return this.$utils.link(node,<Divider type="vertical" />)
          }
        }
      ],
      data: [],
      loading: false,
      params: {
        name:null,
        organizationName:null,
      },
    }
  },
  created() {
    this.def = { ...this.params }
    this.search()
  },

  methods: {

    search() {
      let { rangeTime , ...search } = this.params
      if( rangeTime ){
        search.startDate = rangeTime[0]
        search.endDate = rangeTime[1]
      }

      let params = { search, pageSize: this.page.pageSize, pageNum: this.page.pageNum }
      this.loading = true
      this.$request.companyInspections(params).then(resp => {
        this.loading = false
        if (!resp.code) {
          this.data = this.$utils.conv(resp.data.list || [], { 'createDatetime': 'datetime'})
          this.page.total = resp.data.total || 0
        }
      })
    },
    view({ row }) {
      this.$refs['itemView'].init(row.id)
    },
    edit({ row }) {
      this.$refs['item'].init(row.id)
    },

    create() {
      this.$refs['item'].init(0)
    },

    toggle({row}){
      let tip = row.status !=0 ? '启用' : '禁用'
      this.$ui.confirm(this.$request.noticeToggle, `确定${tip} ${row.gfName} ？`)(row.id).then(resp => {
        if (!resp.code) {
          this.$Message.success('操作成功')
          this.search()
        } else {
          this.$Message.error(resp.msg)
        }
      })
    },

    remove({ row }) {
      this.$ui.confirm(this.$request.companyInspectionDelete, `确定删除 ${row.title} ？`)(row.id).then(resp => {
        if (!resp.code) {
          this.$Message.success('操作成功')
          this.search()
        } else {
          this.$Notice.error({
            title: '删除发生错误',
            desc: resp.msg,
          });
        }
      })
    },

    reset() {
      this.$utils.fill(this.params, this.def)
      this.search()
    },

    handleUpdate() {
      this.modalVisible = false
      this.search()
    },
  },

  render(){
    const { create,reset, search, columns , loading , page , data , handleUpdate,params , handleSearchChange} = this
    const slots = {
      action:()=>{
        return <Button type="primary" icon="md-add" on-click={create}>新增</Button>
      }
    }
    return (
      <sl-page>
        <div class='page-filter border-bottom'>
          <sl-search on-reset={reset} on-search={search} scopedSlots={slots}>
            <sl-search-item>
              <sl-select dict="company" v-model={params.organizationId} placeholder="巡检网点" />
            </sl-search-item>
            <sl-search-item>
              <Input v-model={params.organizationName} placeholder="适用单位" />
            </sl-search-item>
          </sl-search>
        </div>
        <div class="pg-bd">
          <sl-table loading={loading} page={page} columns={columns} data={data} on-change={this.$tableChange}></sl-table>
        </div>
        <Item ref="item" on-update={handleUpdate} />
        <View ref="itemView" />
      </sl-page>
    )
  }
}
